
export const base64UrlToUint8Array = (base64UrlData: string): Uint8Array => {
  const padding = '='.repeat((4 - base64UrlData.length % 4) % 4);
  const base64 = (base64UrlData + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const buffer = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    buffer[i] = rawData.charCodeAt(i);
  }
  return buffer;
}

export const isPushNotificationSupported = (): boolean => {
  if (!('serviceWorker' in navigator)) {
    return false
  }

  if (!('PushManager' in window)) {
    return false
  }

  if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
    return false
  }

  return true
}

export const askPermissionForPushNotification = async (): Promise<boolean> => {
  const permissionResult = await Notification.requestPermission()
  return permissionResult === 'granted'
}

export const subscribeUserToPushNotification = async (): Promise<PushSubscription> => {
  try {
    if (!process.env.WEB_PUSH_NOTIFICATION_PUBLIC_KEY) {
      throw Error('No push notification public key!');
    }

    const registration = await navigator.serviceWorker.register('/service-worker.js')
    await navigator.serviceWorker.ready
    const subscribeOptions = {
      userVisibleOnly: true,
      applicationServerKey: base64UrlToUint8Array(process.env.WEB_PUSH_NOTIFICATION_PUBLIC_KEY),
    };
    return await registration.pushManager.subscribe(subscribeOptions)
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const unsubscribeUserFromPushNotification = async (): Promise<boolean> => {
  try {
    if ((await navigator.serviceWorker.getRegistrations()).length === 0) {
      return true
    }

    await navigator.serviceWorker.ready
    const sub = await getPushNotificationSubscription()
    if (sub) {
      return await sub.unsubscribe()
    }
    return true
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const getPushNotificationSubscription = async (): Promise<PushSubscription | null> => {
  try {
    if ((await navigator.serviceWorker.getRegistrations()).length === 0) {
      return null
    }

    const registration = await navigator.serviceWorker.ready
    return await registration.pushManager.getSubscription()
  } catch (e) {
    console.log(e)
    return null
  }
}